export default {

    disabled: [
    ],
    enabled: [
        'main.encryptUid',
        'main.e2ee'

    ] as string[]

};
